
    import { getData, getDefaults } from './src/js/siteData.js';

    document.addEventListener('DOMContentLoaded', () => {
      const facilityGrid = document.getElementById('facilityGrid');
      let facilities = getData('facilities');
      if (!facilities || !Array.isArray(facilities) || facilities.length === 0) {
        facilities = getDefaults('facilities') || [];
      }

      if (facilityGrid && facilities.length > 0) {
        facilityGrid.innerHTML = facilities.map(f => {
          const photoCount = (f.photos || []).filter(p => p.active !== false).length;
          const tagsHtml = (f.tags || []).map(t => `
            <span class="facility-tag-pill"><i class="fa-solid fa-check-circle" style="color:var(--clr-primary)"></i> ${t}</span>
          `).join('');

          return `
            <div class="facility-card reveal revealed" data-category="${f.category ? f.category.toLowerCase() : 'all'}">
              <div class="facility-visual ${f.themeClass || 'theme-library'}">
                <i class="fa-solid ${f.icon || 'fa-building'} facility-icon-bg"></i>
                <div class="facility-icon-bubble"><i class="fa-solid ${f.icon || 'fa-building'}"></i></div>
                <span class="facility-badge-status">${f.status || 'Available'}</span>
              </div>
              <div class="facility-body">
                <span class="facility-cat">${f.category || 'Facility'}</span>
                <h3 class="facility-title">${f.name}</h3>
                <p class="facility-desc">${f.description}</p>
                <div class="facility-tags-wrap">${tagsHtml}</div>
              </div>
              <div class="facility-footer">
                <span class="facility-hours"><i class="fa-solid fa-clock"></i> ${f.operatingHours || 'Mon–Sat'}</span>
                <a href="facility-details.html?id=${f.id}" class="btn btn--sm btn--primary">
                  <i class="fa-solid fa-camera"></i> Photos (${photoCount})
                </a>
              </div>
            </div>
          `;
        }).join('');
      }

      // Filtering Logic
      const filterBtns = document.querySelectorAll('#facilityFilterBar .gallery-filter-btn');
      filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          filterBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          const category = btn.getAttribute('data-filter').toLowerCase();
          const cards = document.querySelectorAll('#facilityGrid .facility-card');
          cards.forEach(card => {
            const cardCat = card.getAttribute('data-category') || '';
            if (category === 'all' || cardCat.includes(category)) {
              card.style.display = 'flex';
            } else {
              card.style.display = 'none';
            }
          });
        });
      });
    });
  